<template>
    <div style="display:flex; height: 100%;">
        <v-row style="margin: 0px; height: 100%; align-self: center;">
            <v-col class="tableauCalepinage colsCalepinage" cols="3">
                <v-data-table 
                    class="tableCalepinage" 
                    :items="rampants" 
                    :headers="headerRampants" 
                    :items-per-page="-1"
                    :item-class="getRowClassSourceRampant"
                    fixed-header 
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>
                                {{ $t('_rampants_') }}
                            </v-toolbar-title>
                        </v-toolbar>
                    </template>
                </v-data-table>

                <v-data-table 
                    class="tableCalepinage" 
                    :items="historiqueOnduleurs" 
                    :headers="headerOnduleurs"
                    :items-per-page="-1" 
                    :item-class="getRowClassSourceOnduleur"
                    fixed-header 
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>
                                {{ $t('_onduleurs_') }}
                            </v-toolbar-title>
                        </v-toolbar>
                    </template>
                </v-data-table>
            </v-col>

            <v-col class="colsCalepinage" cols="3">
                <div class="ligne" style="margin-bottom: 1rem;">
                    <div class="nom">{{ $t("_type_de_configuration_") }}</div>
                    <select class="createSelect" v-model="typeConfig" :disabled="calepinage.length > 0">
                        <option value="onduleur">{{ $t("_configuration_par_entree_onduleur_") }}</option>
                        <option value="mppt">{{ $t("_configuration_par_mppt_") }}</option>
                        <option value="alegee">{{ $t("_configuration_allegee_") }}</option>
                        <option value="minimaliste">{{ $t("_configuration_minimaliste_") }}</option>
                    </select>
                    <div v-if="calepinage.length > 0" style="display: flex; align-items: center; gap: 4px;">
                        <v-icon color="#ff9800" small> mdi-alert </v-icon>
                        <small style="color: #ff9800; font-style: italic; display: inline-block; margin-top: 0; font-size: 0.75rem;">
                            {{ $t('_supprimer_tous_les_elements_pour_changer_de_configuration_!_') }}
                        </small>                        
                    </div>
                </div>

                <div>
                    <div class="ligne">
                        <div v-if="typeConfig == 'onduleur' || typeConfig == 'mppt'" class="nom">{{ $t('_onduleurs_') }}</div>
                        <div v-else-if="typeConfig == 'alegee'" class="nom">{{ $t('_chaines_par_rampant_') }}</div>
                        <div v-else-if="typeConfig == 'minimaliste'" class="nom">{{ $t('_modules_par_rampant_') }}</div>
                    </div>
                    
                    <div class="groupe">
                        <div class="block" v-if="isFieldVisible('idOnduleur')">
                            <div class="champs">
                                <div class="nom">
                                    <span v-if="typeConfig === 'alegee' || typeConfig === 'minimaliste'">Onduleur (*)</span>
                                    <span v-else>{{ $t('_nom_') }} (*)</span>
                                </div>
                                <select 
                                    class="createSelect" 
                                    v-model="reponse.idOnduleur.value"
                                    :class="{'border-red': onduleursManquants.length > 0}"
                                >
                                    <option 
                                        v-for="(inv, index) in historiqueOnduleurs" 
                                        :value="inv.id" 
                                        :key="index"
                                        :class="{'option-manquante': onduleursManquants.includes(inv.id)}"
                                    >
                                        {{ inv.id }} - {{ inv.nom }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="block" v-if="isFieldVisible('entreeDC')">
                            <div class="champs">
                                <div class="nom">{{ $t("_entree_DC_") }} (*)</div>
                                <select :disabled="reponse.idOnduleur.value === reponseVide.idOnduleur.value" class="createSelect"
                                    v-model="reponse.entreeDC.value">
                                    <option v-for="i in findNbMPPT()" :value="findNameFromId(reponse.idOnduleur.value) + '.' + i"
                                        :key="i">
                                        {{ findNameFromId(reponse.idOnduleur.value) }}.{{ i }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="block" v-if="isFieldVisible('mppt')">
                            <div class="champs">
                                <div class="nom">{{ $t("_MPPT_") }} (*)</div>
                                <select :disabled="reponse.idOnduleur.value === reponseVide.idOnduleur.value" class="createSelect"
                                    v-model="reponse.mppt.value">
                                    <option v-for="i in findNbMPPT()" :value="findNameFromId(reponse.idOnduleur.value) + '.' + i"
                                        :key="i">
                                        {{ findNameFromId(reponse.idOnduleur.value) }}.{{ i }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="champs">
                    <div class="nom">{{ $t('_nom_rampant_') }} (*)</div>
                    <select 
                        class="createSelect" 
                        v-model="reponse.idRampant.value"
                        :class="{'border-red': rampantsManquants.length > 0}"
                    >
                        <option 
                            v-for="(rampant, index) in rampants" 
                            :value="rampant.id" 
                            :key="index"
                            :class="{'text-red': rampantsManquants.includes(rampant.id)}"
                        >
                            {{ rampant.id }} - {{ rampant.nomRampant }}
                        </option>
                    </select>
                </div>

                <div class="ligne">
                    <div class="nom">{{ $t('_modules_') }}</div>
                </div>

                <div class="groupe">
                    <div class="block" v-if="isFieldVisible('nbChaine')">
                        <div class="champs">
                        <div class="nom">{{ $t("_nb_de_chaines_") }} (*)</div>
                        <v-text-field
                            color="orange"
                            label=""
                            outlined
                            class="inputField"
                            v-model="reponse.nbChaine.value"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                        />
                        </div>
                    </div>

                    <div class="block">
                        <div class="champs">
                        <div v-if="typeConfig == 'minimaliste'" class="nom">{{ $t("_nb_de_modules_par_rampant_") }} (*)</div>
                        <div v-else class="nom">{{ $t("_nb_de_modules_") }} (*)</div>
                        <v-text-field
                            color="orange"
                            label=""
                            outlined
                            class="inputField"
                            v-model="reponse.nbModule.value"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                        />
                        </div>
                    </div>
                </div>

                <div class="champs" v-if="isFieldVisible('typeModule')">
                    <div class="nom">{{ $t('_type_modules_') }} (*)</div>
                    <select 
                        class="createSelect" 
                        v-model="reponse.typeModule.value"
                        :class="{'border-red': modulesManquants.length > 0}"
                    >
                        <option 
                            v-for="(module, index) in modules" 
                            :value="module.ref" 
                            :key="index"
                            :class="{'option-manquante': modulesManquants.includes(module.ref)}"
                        >
                            {{ module.ref }}
                        </option>
                    </select>
                </div>

                <v-btn v-if="!edition" :disabled="!rempli"
                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw;  font-size: 1rem;"
                    @click="addData()">
                    {{ $t('_ajouter_') }}
                </v-btn>
                <div v-else>
                    <v-btn :disabled="!rempli"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="editData()">
                        {{ $t('_modifier_') }}
                    </v-btn>
                    <v-btn
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="cancelEdit()">
                        {{ $t('_annuler_') }}
                    </v-btn>
                </div>
            </v-col>

            <v-col class="tableauCalepinage colsCalepinage" cols="6">
                <div style="display: flex; justify-content: space-between; width: 100%; gap: 40px;">
                    <div style="height: fit-content; align-self: center; flex: 1;">
                        {{ $t("_dupliquer_le_chargement_d_un_onduleur_") }}
                    </div>
                    
                    <div style="width: 15%; display: flex; flex-direction: column;">
                        <div style="font-size: 0.8rem; line-height: 1.2; margin-bottom: 4px;">{{ $t("_depuis_") }}:</div>
                        <select class="createSelect compact-select" v-model="invADupliquer">
                            <option v-for="inv in getListInv()" :value="inv" :key="inv">
                                {{ findNameFromId(inv) }}
                            </option>
                        </select>
                    </div>

                    <div style="width: 15%; display: flex; flex-direction: column;">
                        <div style="font-size: 0.8rem; line-height: 1.2; margin-bottom: 4px;">{{ $t("_vers_") }}: </div>
                        <select :disabled="invADupliquer === ''" class="createSelect compact-select" v-model="invDestDuplicage">
                            <option v-for="inv in getSameMPPT()" :value="inv" :key="inv">
                                {{ findNameFromId(inv) }}
                            </option>
                        </select>
                    </div>

                    <v-btn :disabled="invADupliquer === '' || invDestDuplicage === ''"
                        style="background-color: #d9d9d9; height: 32px; padding: 0 15px; font-size: 0.85rem; align-self: flex-end; margin-bottom: 2px;"
                        @click="duplicateData()">
                        {{ $t('_dupliquer_') }}
                    </v-btn>
                </div>
                
                <v-data-table 
                    class="calepinageTable" 
                    :item-class="getRowClass" 
                    :items="calepinage"
                    :headers="headerCalepinage" 
                    :items-per-page="-1" 
                    @click:row="editItem" 
                    fixed-header
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_calepinage_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click.stop="deleteItem(item)">
                            mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

                <div style="display: flex; justify-content: flex-end; margin-top: 5px; padding: 10px; border: 2px solid black; border-radius: 4px;">
                    <div style="font-weight: bold; font-size: 1.1rem;">
                        {{ $t("_puissance_totale_") }} : 
                        <span     style="
                            color: #ff9800;
                            margin-left: 10px;
                            margin-top: 8px;
                            display: inline-flex;
                            align-items: center;
                        ">
                            {{ calculerValeurSpecifique() }} {{ $t("_kWp_") }}
                        </span>
                    </div>
                </div>
                <div
                    v-if="calepinageErrorMessageHtml()"
                    v-html="calepinageErrorMessageHtml()"
                    style="color: #d32f2f; font-size: 0.9rem; font-style: italic; text-align: left; max-width: 60%; white-space: pre-line; display: flex; justify-content: flex-end; margin-top: 5px; font-weight: bold;"
                ></div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        onduleurs: { required: true },
        historiqueOnduleurs: { required: true },
        rampants: { required: true },
        modules: { required: true },
        initCalepinage: { required: false },
        initialTypeConfig: { required: false, type: String }, 
        install_id: { required: true }
    },

    data() {
        return {
            typeConfig: "onduleur",
            calepinage: [],
            nbMPPT: 0,
            listeModeleOnduleur: null,
            listeNouveuxOnduleur: null,
            invADupliquer: "",
            invDestDuplicage: "",
            rempli: false,
            edition: false,
            indexEdite: null,
            formConfigs: {
                onduleur: {
                    required: ["idOnduleur", "entreeDC", "idRampant", "nbChaine", "nbModule", "typeModule"],
                    visible: ["idOnduleur", "entreeDC", "idRampant", "nbChaine", "nbModule", "typeModule"],
                },
                mppt: {
                    required: ["idOnduleur", "mppt", "idRampant", "nbChaine", "nbModule", "typeModule"],
                    visible: ["idOnduleur", "mppt", "idRampant", "nbChaine", "nbModule", "typeModule"],
                },
                alegee: {
                    required: ["idRampant", "nbModule", "typeModule", "nbChaine", "idOnduleur"],
                    visible: ["idRampant", "nbModule", "typeModule", "nbChaine", "idOnduleur"],
                },
                minimaliste: {
                    required: ["idOnduleur", "idRampant", "nbModule", "typeModule"],
                    visible: ["idOnduleur", "idRampant", "nbModule", "typeModule"], 
                },
            },
            headerRampants: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nomRampant', text: this.$t('_nom_rampant_'), value: 'nomRampant' },
                { key: 'orientationPV', text: this.$t('_orientation_'), value: 'orientationPV' },
                { key: 'inclinaisonPV', text: this.$t('_inclinaison_'), value: 'inclinaisonPV' },
            ],
            headerOnduleurs: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nom', text: this.$t('_nom_'), value: 'nom' },
                { key: 'type', text: this.$t('_type_d_onduleur_'), value: 'type' },
            ],
            reponse: {
                "id": { "value": "", "required": false },
                "cleMpp":{ "value": "", "required": false },
                "nom": { "value": "", "required": false },
                "idOnduleur": { "value": "", "required": true },
                "entreeDC": { "value": "", "required": true },
                "idRampant": { "value": "", "required": true },
                "nbChaine": { "value": "", "required": true },
                "nbModule": { "value": "", "required": true },
                "typeModule": { "value": "", "required": true },
                "mppt": { "value": "", "required": true }
            },
            reponseVide: {
                "id": { "value": "", "required": false },
                "nom": { "value": "", "required": false },
                "cleMpp":{ "value": "", "required": false },
                "idOnduleur": { "value": "", "required": true },
                "entreeDC": { "value": "", "required": true },
                "idRampant": { "value": "", "required": true },
                "nbChaine": { "value": "", "required": true },
                "nbModule": { "value": "", "required": true },
                "typeModule": { "value": "", "required": true },
                "mppt": { "value": "", "required": true }
            }
        }
    },

    computed: {
        onduleursManquants() {
            const idsUtilises = this.calepinage.map(c => String(c.idOnduleur));
            return this.historiqueOnduleurs
                .filter(inv => !idsUtilises.includes(String(inv.id)))
                .map(inv => inv.id);
        },
        rampantsManquants() {
            const idsUtilises = this.calepinage.map(c => String(c.idRampant));
            return this.rampants
                .filter(r => !idsUtilises.includes(String(r.id)))
                .map(r => r.id);
        },
        modulesManquants() {
            const refsUtilisees = this.calepinage.map(c => String(c.typeModule));
            return this.modules
                .filter(m => !refsUtilisees.includes(String(m.ref)))
                .map(m => m.ref);
        },
        isCalepinageInvalide() {
            const aDesIncoherences = this.calepinage.some(item => {
                const onduleurValide = this.historiqueOnduleurs.some(inv => inv.id === item.idOnduleur);
                const rampantValide = this.rampants.some(r => r.id === item.idRampant);
                const moduleValide = this.modules.some(m => m.ref === item.typeModule);
                return !onduleurValide || !rampantValide || !moduleValide;
            });

            const estIncomplet = 
                this.onduleursManquants.length > 0 || 
                this.rampantsManquants.length > 0 || 
                this.modulesManquants.length > 0;

            return aDesIncoherences || estIncomplet;
        },

        headerCalepinage() {
            let headers = [
                { key: 'idOnduleur', text: this.$t('_id_onduleur_'), value: 'idOnduleur' },
                { key: 'nom', text: this.$t('_point_de_mesure_'), value: 'nom' },
                { key: 'idRampant', text: this.$t('_id_rampant_'), value: 'idRampant' },
                { key: 'typeModule', text: this.$t('_type_modules_'), value: 'typeModule' },
                { 
                    key: 'nbModule', 
                    text: this.typeConfig === 'minimaliste' ? this.$t('_nb_modules_rampants_') : this.$t('_nb_modules_chaine_'), 
                    value: 'nbModule' 
                },
                { key: 'nbChaine', text: this.$t('_nb_chaines_en_parallele_'), value: 'nbChaine' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ];

            if (this.typeConfig === 'minimaliste') {
                headers = headers.filter(h => h.key !== 'nbChaine');
            }
            return headers;
        }
    },

    async mounted() {
        if (this.initCalepinage) this.calepinage = this.initCalepinage;
        if (this.initialTypeConfig) this.typeConfig = this.initialTypeConfig;
        this.autoSelectInit();
    },

    methods: {
        isNotMissing(list, value) {
            if (!list || list.length === 0) return false;
            return !list.some(item => String(item) === String(value));
        },

        verifierEtatBouton() {
            if (this.calepinage.length > 0) {
                if (this.isCalepinageInvalide) {
                    this.$emit('disable', 'coherence');
                } else {
                    this.$emit('enable');
                }
            } else {
                this.$emit('disable');
            }
        },

        // Classes pour les tableaux de gauche (Sources)
        getRowClassSourceOnduleur(item) {
            return this.onduleursManquants.includes(item.id) ? 'row-unused' : '';
        },

        getRowClassSourceRampant(item) {
            return this.rampantsManquants.includes(item.id) ? 'row-unused' : '';
        },

        autoSelectInit() {
            if (this.historiqueOnduleurs?.length === 1) this.reponse.idOnduleur.value = this.historiqueOnduleurs[0].id;
            if (this.rampants?.length === 1) this.reponse.idRampant.value = this.rampants[0].id;
            if (this.modules?.length === 1) this.reponse.typeModule.value = this.modules[0].ref;
        },

        findNameFromId(id) {
            const inv = this.historiqueOnduleurs.find(i => i.id === id);
            return inv ? inv.nom : "";
        },

        isFieldVisible(fieldName) {
            return this.formConfigs[this.typeConfig]?.visible.includes(fieldName) || false;
        },

        findNbMPPT() {
            const idOnduleur = this.reponse.idOnduleur.value;
            if (!idOnduleur) return 0;
            const invHisto = this.historiqueOnduleurs.find(i => i.id === idOnduleur);
            if (!invHisto) return 0;
            const modelRef = this.onduleurs.find(inv => inv.modele === invHisto.type);
            return modelRef ? Number(modelRef.nb_mppt) : 0;
        },

        getListInv() {
            return [...new Set(this.calepinage.map(c => c.idOnduleur))];
        },

        getSameMPPT() {
            if (!this.invADupliquer) return [];
            const nbRef = this.getNbMPPTById(this.invADupliquer);
            return this.historiqueOnduleurs
                .filter(inv => inv.id !== this.invADupliquer && this.getNbMPPTById(inv.id) === nbRef)
                .map(inv => inv.id);
        },

        getNbMPPTById(id) {
            const invHisto = this.historiqueOnduleurs.find(i => i.id === id);
            if (!invHisto) return 0;
            const modelRef = this.onduleurs.find(inv => inv.modele === invHisto.type);
            return modelRef ? Number(modelRef.nb_mppt) : 0;
        },

        findNextAvailableMpptNumber(targetInvId, baseMpptIndex) {
            let nextIndex = parseInt(baseMpptIndex) || 1;
            const targetInvName = this.findNameFromId(targetInvId);
            let isAvailable = false;

            while (!isAvailable) {
                const potentialDC = `${targetInvName}.${nextIndex}`;
                const alreadyUsed = this.calepinage.some(
                    c => c.idOnduleur === targetInvId && c.entreeDC === potentialDC
                );

                if (!alreadyUsed) {
                    isAvailable = true;
                } else {
                    nextIndex++;
                }
            }
            return nextIndex.toString();
        },

        async duplicateData() {
            const itemsToDuplicate = this.calepinage.filter(c => c.idOnduleur === this.invADupliquer);
            for (let calp of itemsToDuplicate) {
                this.reponse.idOnduleur.value = this.invDestDuplicage;
                const sourceMpptIndex = calp.entreeDC.split(".")[1];
                const newNum = this.findNextAvailableMpptNumber(this.invDestDuplicage, sourceMpptIndex);
                this.reponse.entreeDC.value = `${this.findNameFromId(this.invDestDuplicage)}.${newNum}`;
                
                for (let field in this.reponse) {
                    if (!["cleMpp", "nom", "idOnduleur", "entreeDC"].includes(field)) {
                        this.reponse[field].value = calp[field];
                    }
                }
                await this.$nextTick();
                this.addData();
            }
            this.invADupliquer = "";
            this.invDestDuplicage = "";
        },

        editItem(item) {
            this.edition = true;
            this.indexEdite = this.calepinage.indexOf(item);
            for (let field in item) {
                if (this.reponse[field]) this.reponse[field].value = item[field];
            }
        },

        cancelEdit() {
            this.edition = false;
            this.indexEdite = null;
            this.resetForm();
        },

        resetForm() {
            for (let field in this.reponseVide) {
                this.reponse[field] = JSON.parse(JSON.stringify(this.reponseVide[field]));
            }
            this.$nextTick(() => this.autoSelectInit());
        },

        editData() {
            const entryValue = this.typeConfig === 'mppt' ? this.reponse.mppt.value : this.reponse.entreeDC.value;
            if (this.reponse.nom.value === "") this.reponse.nom.value = entryValue;
            
            for (let field in this.reponse) {
                this.calepinage[this.indexEdite][field] = this.reponse[field].value;
            }
            const mpptIdx = entryValue.split(".")[1];
            this.calepinage[this.indexEdite].cleMpp = `${this.reponse.idOnduleur.value}-${mpptIdx}`;
            
            this.edition = false;
            this.indexEdite = null;
            this.resetForm();
        },

        getRowClass(item) {
            let classes = [];
            if (this.indexEdite === this.calepinage.indexOf(item)) classes.push('lineEdit');
            
            const onduleurExiste = this.historiqueOnduleurs.some(inv => inv.id === item.idOnduleur);
            const rampantExiste = this.rampants.some(r => r.id === item.idRampant);
            const moduleExiste = this.modules.some(m => m.ref === item.typeModule);
            
            if (!onduleurExiste || !rampantExiste || !moduleExiste) classes.push('row-incoherent');
            return classes.join(' ');
        },

        addData() {
            if (!this.rempli) return;
            
            const invId = this.reponse.idOnduleur.value;
            if (['alegee', 'minimaliste'].includes(this.typeConfig)) {
                const newNum = this.findNextAvailableMpptNumber(invId, "1");
                const entry = `${this.findNameFromId(invId)}.${newNum}`;
                if (!this.reponse.entreeDC.value) this.reponse.entreeDC.value = entry;
                if (!this.reponse.mppt.value) this.reponse.mppt.value = entry;
            }

            if (this.typeConfig === 'minimaliste') this.reponse.nbChaine.value = "N/A";
            
            const sourceVal = this.typeConfig === 'mppt' ? this.reponse.mppt.value : this.reponse.entreeDC.value;
            if (!this.reponse.nom.value) this.reponse.nom.value = sourceVal;
            
            this.reponse.id.value = this.calepinage.length + 1;
            this.reponse.cleMpp.value = `${invId}-${sourceVal.split(".")[1]}`;
            
            let dataToPush = {};
            for (let field in this.reponse) dataToPush[field] = this.reponse[field].value;
            
            this.calepinage.push(dataToPush);
            this.resetForm();
        },

        deleteItem(item) {
            this.calepinage.splice(this.calepinage.indexOf(item), 1);
            this.calepinage.forEach((c, i) => c.id = i + 1);
            if (this.edition) this.cancelEdit();
        },

        calculerValeurSpecifique() {
            let total = 0;
            this.calepinage.forEach(item => {
                let pUnit = 0;
                if (item.typeModule) {
                    const parts = item.typeModule.split('-');
                    pUnit = parseInt(parts[parts.length - 1]) || 0;
                }
                const nMod = parseInt(item.nbModule) || 0;
                const nChaine = item.nbChaine === "N/A" ? 1 : (parseInt(item.nbChaine) || 0);
                total += (pUnit * nMod * nChaine) / 1000;
                total = Number(total.toFixed(2));
            });
            return total;
        },

        calepinageErrorMessageHtml() { 
            if (!this.isCalepinageInvalide) return '';

            const erreursOnduleurs = new Set();
            const erreursRampants = new Set();
            const erreursModules = new Set();

            this.calepinage.forEach(item => {
                if (!this.historiqueOnduleurs.some(inv => inv.id === item.idOnduleur)) erreursOnduleurs.add(item.idOnduleur);
                if (!this.rampants.some(r => r.id === item.idRampant)) erreursRampants.add(item.idRampant);
                if (!this.modules.some(m => m.ref === item.typeModule)) erreursModules.add(item.typeModule);
            });

            const messages = [];

            if (erreursOnduleurs.size > 0) {
                const premier = Array.from(erreursOnduleurs)[0];
                messages.push(this.$t('_onduleurs_inexistants_') + ' : ' + premier);
            }

            if (erreursRampants.size > 0) {
                const premier = Array.from(erreursRampants)[0];
                messages.push(this.$t('_rampants_inexistants_') + ' : ' + premier);
            }

            if (erreursModules.size > 0) {
                const premier = Array.from(erreursModules)[0];
                messages.push(this.$t('_modules_inexistants_') + ' : ' + premier);
            }
            return messages.join('<br>');
        }

    },

    watch: {
        typeConfig: {
            handler(newConfig) {
                this.cancelEdit();
                const config = this.formConfigs[newConfig];
                if (!config) return;
                for (const field in this.reponse) {
                    if (this.reponse[field].hasOwnProperty('required')) {
                        this.reponse[field].required = config.required.includes(field);
                    }
                    if (!config.visible.includes(field) && !config.required.includes(field)) {
                        this.reponse[field].value = "";
                    }
                }
                this.$nextTick(() => this.autoSelectInit());
            },
            immediate: true
        },

        calepinage: {
            handler() { this.verifierEtatBouton(); },
            deep: true,
            immediate: true
        },

        historiqueOnduleurs: {
            handler() { this.verifierEtatBouton(); },
            deep: true
        },

        rampants: {
            handler() { this.verifierEtatBouton(); },
            deep: true
        },

        'reponse.idOnduleur.value': function(val) {
            if (val && this.findNbMPPT() === 1) {
                const autoVal = `${this.findNameFromId(val)}.1`;
                if (this.typeConfig === 'mppt') this.reponse.mppt.value = autoVal;
                else this.reponse.entreeDC.value = autoVal;
            }
        },

        'reponse.mppt.value': function(val) {
            if (this.typeConfig === 'mppt') {
                this.reponse.entreeDC.value = val;
                this.reponse.nom.value = val;
            }
        },

        reponse: {
            handler() {
                const config = this.formConfigs[this.typeConfig];
                this.rempli = config ? config.required.every(f => this.reponse[f]?.value !== "") : false;
                this.$emit("answer", { calepinage: this.calepinage, typeConfig: this.typeConfig });
            },
            deep: true
        }
    }
}
</script>

<style scoped>

.createSelect, .compact-select {
    background-color: white;
}

.compact-select {
    height: 32px !important;
}

::v-deep .row-incoherent {
    background-color: #ffcdd2 !important;
}

::v-deep .row-incoherent td {
    color: #b71c1c !important;
}

::v-deep .lineEdit {
    background-color: #fff3e0 !important;
}

.groupe:has(.block:first-child:last-child) .block {
  flex: 1 1 100%;
}

.ligne {
    font-weight: bolder;
}

.tableauCalepinage {
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    height: 100%;
    width: 100%;
}

.tableauCalepinage .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
}

.tableauCalepinage .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.calepinageTable {
    height: 60vh;
    max-height: 65%;
    overflow-y: auto;
}

.calepinageTable>>>.lineEdit {
    background-color: #d9d9d9;
}

.tableCalepinage {
    height: 30vh;
    max-height: 48%;
    width: 100%;
    overflow-y: auto;
    display: block;
}


.block {
    flex: 1;
    display: table-column;
}

.groupe {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    align-items: flex-end;
    width: 100%;
}

.colsCalepinage {
    margin-bottom: 10px;
    padding-left: 6px;
    padding-right: 6px;
}

.border-red {
    border: 0.5px solid red !important;
    outline: 0.5px solid red !important;
}

.option-manquante {
    color: red !important;
    font-weight: bold;
}

:deep(.row-unused) {
    color: red !important;
    background-color: #fff0f0;
}

.text-alert {
    color: red;
    font-size: 0.8em;
    margin-left: 5px;
}

.row-incoherent {
    background-color: #ffcccc !important;
}
.lineEdit {
    background-color: #e0f7fa !important;
}

.text-red {
    color: red !important;
    font-weight: bold;
}

</style>
